/// <amd-module name="Build/Pipelines/Performance" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

const area = "Build";
const scenario = "Pipelines.Pipelines";

let _isFPS = false;
export function disposeFPS() {
    _isFPS = false;
}

export class Performance {
    private _service: IVssPerformanceService;
    constructor(pageContext: IVssPageContext) {
        this._service = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public onFPS() {
        this._service.startScenario(scenario, true);
        _isFPS = true;
    }

    public mark(view: string, definitionId?: number, path?: string) {
        const data = {
            view: view,
            ...(definitionId || path) ? {
                definitionId: definitionId,
                definitionScope: path
            } : {},

        };
        if (_isFPS) {
            this._service.endScenario(area, scenario, true, undefined, data);
        }
        else {
            this._service.markTimeToInteractive(area, scenario, undefined, data);
        }
    }
}